<template>
  <AppNotification :border-color="borderColor()">
    <template #header>
      <p class="heading-xxs">{{ configData.Title }}</p>
    </template>
    <div class="flex flex-col gap-8">
      <p v-html="message"></p>
    </div>
  </AppNotification>
</template>

<script lang="ts" setup>
import { markup_markdownLikeTextToHtmlString } from '~/utils/markup/allTextTransformations';

interface Props {
  configData: {
    Type: string | 'info';
    Title: string | '';
    Message: string | '';
  };
}

const props = defineProps<Props>();
const message = markup_markdownLikeTextToHtmlString(props.configData?.Message);

const borderColor = () => {
  switch (props.configData.Type) {
    case 'success': {
      return 'border-border-success';
    }
    case 'warning': {
      return 'border-border-warning';
    }
    case 'error': {
      return 'border-border-error';
    }
    case 'info': {
      return 'border-border-information';
    }
    default: {
      return 'border-border-information';
    }
  }
};
</script>

<style scoped></style>
